import { EColors } from "common/styles";
import { Styled } from "components/Styled";
import styled from "styled-components";

export const StyledFuelListCard = styled.ul`
display: flex;
flex-direction:column;
gap:24px;
@media screen and (min-width: 768px) {
    display: grid;
    grid-template-columns:1fr 1fr 1fr;
  }
`

export const StyledCardItem = styled.li`
display: flex;
flex-direction: column;
align-items: flex-start;
padding: 48px 36px;
gap:24px;
width:100%;
max-width: 416px;
max-height:auto;
border-radius: 12px;
background:${EColors.accent_300};
&:nth-child(2){
  background:${EColors.primary_200}
}
@media screen and (max-width: 767px) {
max-width:100%;
padding: 32px 16px;
gap:16px;
}
`
export const ImageFuel = styled.img`
width:100%;
height:100%;
margin-top:48px;
@media screen and (max-width: 767px) {
  margin-top:32px;
}
`
